import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import styles from './panel.module.css'

const propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    onClick: PropTypes.func
}

/**
 * Render a {@link Panel} header button component. Privately
 * used by PanelHeader
 *
 * @param {Object} [props] - The current component properties
 * @param {ReactElement|string|number} [props.children] - The children to be rendered
 * @param {string} [props.className] - Classname to be added
 * @param {Function} [props.onClick] - Event handler when button get's clicked
 * @returns {ReactElement}
 */
function PanelHeaderButton(props) {
    const { children, className, onClick } = props

    const classNameMerged = cx(styles['panel-header-button'], className, 't3sel-panel-header-button')

    if (onClick) {
        return (
            <button className={classNameMerged} {...{ onClick }}>
                {children}
            </button>
        )
    }

    return <div className={classNameMerged}>{children}</div>
}

PanelHeaderButton.propTypes = propTypes

export default PanelHeaderButton
